var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"timeout":4000,"top":true},model:{value:(_vm.showSnackbar),callback:function ($$v) {_vm.showSnackbar=$$v},expression:"showSnackbar"}},[_vm._v("\n  "+_vm._s(_vm.snackbarText)+"\n  "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){return _vm.closeSnackbar.apply(null, arguments)}}},[_vm._v("\n    Close\n  ")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d58e5d1","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/utils/Snackbar.vue
// module id = null
// module chunks = 